'use strict';

angular.module('randomization')
    .filter('randomizationBranch', function () {
        return function (data) {
            if (!data) {
                return '';
            }

            var str = '';

            if (data.code) {
                str += data.code;
            }

            if (data.masked) {
                if (str) {
                    str += ' - ';
                }
                str += data.masked;
            }

            if (data.label) {
                if (str) {
                    str += ' (' + data.label + ')';
                } else {
                    str += data.label;
                }
            }

            return str;
        };
    });
